import * as actionTypes from "../actionTypes";
import {store} from "../store";
import {encodeData, getUrlWithFilters} from "../../shared/utils/axiosUtils";
import axios from "axios";
import {toastError, toastSuccess} from "../../shared/components/toast/Toast";
import {getImeiListFromDevices} from "../../shared/utils/utils";
import {TagsService} from "../../api/tagsService";
import {APP_NAME, DEVICE} from "../../shared/utils/constants/general";
import DeviceService from "../../api/deviceService";
import {initialFilterState} from "./helper";
import fileSaver from 'file-saver'

let deviceCancelToken = axios.CancelToken.source();
let suggestionCancelToken = axios.CancelToken.source();

export const getDevices = (page, rowsPerPage) => {
    return (dispatch) => {
        const state = store.getState().deviceReducer;
        const integrationId = store.getState().authReducer.selectedCompany.integrationId;
        const url = getUrlWithFilters(state.device.sorting, page, rowsPerPage, integrationId, state.filter);
        if (state.device.loading) {
            deviceCancelToken.cancel();
            deviceCancelToken = axios.CancelToken.source();
        }
        dispatch({type: actionTypes.SET_LOADING_DEVICES, value: true});
        DeviceService.fetchDevices(encodeData(url), deviceCancelToken.token).then((res) => {
            getDevicesDataSuccess(dispatch, res.data, page, rowsPerPage)
        }).catch((e) => {
            if (!axios.isCancel(e)) {
                dispatch({type: actionTypes.SET_LOADING_DEVICES, value: false});
            }
        })
    }
}

const getDevicesDataSuccess = (dispatch, data, page, rowsPerPage) => {
    dispatch({type: actionTypes.GET_DEVICES, response: data, rowsPerPage: rowsPerPage});
    dispatch({type: actionTypes.SET_LOADING_DEVICES, value: false});
    dispatch({type: actionTypes.SET_WRENCH_LOADING_DEVICES, value: true});
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const changeInSelf = store.getState().authReducer.selectedCompany.changeInSelf;

    const wrenchDetailsDto = {
        imeiList: getImeiListFromDevices(data.data),
        integrationId: integrationId,
        changeInSelf: changeInSelf
    }
    DeviceService.fetchWrenchDetails(wrenchDetailsDto).then((res) => {
        dispatch({type: actionTypes.SET_WRENCH_DETAILS_DEVICE, wrenchDetails: res.data})
    }).catch((e) => {
        console.log(e);
    }).then(() => {
        dispatch({type: actionTypes.SET_WRENCH_LOADING_DEVICES, value: false});
    })
}

export const setSelectedDevice = (device, tags) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({type: actionTypes.SET_LOADING_DEVICE_DETAILS, value: true});
        DeviceService.fetchDeviceDetails(device.id, integrationId).then((res) => {
            const joinedTags = [...tags, ...res.data.tagsForDeviceList];
            const joinedFirstTags = joinedTags.map(t => {
                return {...t}
            })
            dispatch({
                type: actionTypes.SET_SELECTED_DEVICE,
                device: {
                    ...device,
                    ...res.data,
                    tagsForDeviceList: joinedTags,
                    firstRenderTags: joinedFirstTags,
                }
            })
        }).catch((e) => {
            console.error(e);
        }).finally(() => {
            dispatch({type: actionTypes.SET_LOADING_DEVICE_DETAILS, value: false});
        })
    }
}

export const updateDeviceTagsAssociations = (tags, clientName, objectCategoryName, objectExternalId, updatedTags) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return dispatch => {
        DeviceService.updateAssociations(tags, clientName, objectCategoryName, integrationId, objectExternalId).then((res) => {
            console.log(res.data)
            dispatch({
                type: actionTypes.UPDATE_CHANGED_TAGS_DEVICE,
                updatedTags: updatedTags,
                imei: objectExternalId
            })
        }).catch(e => {
            console.log(e);
        })
    }
}

export const fetchDeviceFilterData = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const collaborators = store.getState().simReducer.filterData.collaborators;

    return dispatch => {
        dispatch({type: actionTypes.SET_DEVICE_FILTER_LOADING_OR_ERROR, label: "error", value: false})
        dispatch({type: actionTypes.SET_DEVICE_FILTER_LOADING_OR_ERROR, label: "loading", value: true})
        DeviceService.fetchFilterData(integrationId, collaborators.length === 0).then((res) => {
            dispatch({
                type: actionTypes.SET_DEVICE_FILTER_INPUT_DATA,
                response: collaborators.length === 0 ? res.data : {...res.data, collaborators: collaborators}
            })
        }).catch((e) => {
            console.log(e);
            dispatch({type: actionTypes.SET_DEVICE_FILTER_LOADING_OR_ERROR, label: "error", value: true})
        }).finally(() => {
            dispatch({type: actionTypes.SET_DEVICE_FILTER_LOADING_OR_ERROR, label: "loading", value: false})
        })
    }
}

export const downloadDevicesFromOrderCsv = (setIsFileDownloading) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    setIsFileDownloading(true);
    const orderId = store.getState().ordiniDiSpedizioneReducer.selectedRow.rowId;
    DeviceService.downloadCsvFromOrder(orderId, integrationId).then((response) => {
        fileSaver.saveAs(response.data, `devices-${orderId}.csv`);
    }).catch((e) => {
        console.log(e)
    }).finally(() => {
        setIsFileDownloading(false);
    })
}

export const fetchDeviceFilterSuggestions = (searchText, suggestionBy) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const deviceSuggestionLoading = store.getState().deviceReducer.deviceSuggestion.loading;

    return dispatch => {
        if (deviceSuggestionLoading) {
            suggestionCancelToken.cancel();
            suggestionCancelToken = axios.CancelToken.source();
        }
        const query = encodeData(`?integrationId=${integrationId}&${suggestionBy}=${searchText}`)
        dispatch(setLoadingSuggestionDevice(true))
        DeviceService.fetchFilterSuggestions(query, suggestionCancelToken.token).then((res) => {
            dispatch({
                type: actionTypes.SET_DEVICE_FILTER_SUGGESTION_DATA,
                suggestionList: res.data.data.map(d => {
                    return {
                        text: d.imei
                    }
                })
            })
            dispatch(setLoadingSuggestionDevice(false))
        }).catch((e) => {
            if (!axios.isCancel(e)) {
                dispatch(setLoadingSuggestionDevice(false))
            }
        })
    }
}

export const sendVpServiceRequest = (imeiList, tipoGuasto, indirizzoCompleto, email,
                                     telephone, integrationId, uid) => {
    const changeInSelf = store.getState().authReducer.selectedCompany.changeInSelf;
    const vpServiceRequestDto = {
        imeiList: imeiList,
        telephone: telephone,
        email: email,
        tipoGausto: tipoGuasto,
        indirizzoCompleto: indirizzoCompleto,
        userId: uid,
        integrationId: integrationId,
        changeInSelf: changeInSelf
    }

    return (dispatch) => {
        dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "loading", value: true})
        DeviceService.sendVpServiceRequest(vpServiceRequestDto).then(() => {
            toastSuccess("Operazione completata con successo")
            dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "error", value: false})
        }).catch((e) => {
            toastError("Operazione fallita")
            dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "error", value: true})
            console.error(e)
        }).finally(() => {
            dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "loading", value: false})
        })
    }
}

export const checkActiveSrForDevice = (imeiList) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const changeInSelf = store.getState().authReducer.selectedCompany.changeInSelf;
    const wrenchDetailsDto = {
        imeiList: imeiList,
        integrationId: integrationId,
        changeInSelf: changeInSelf
    }

    return dispatch => {
        dispatch({type: actionTypes.SET_ACTIVE_DEVICE_SERVICE_REQUEST, typeOf: "loading", value: true})
        DeviceService.checkActiveSr(wrenchDetailsDto).then(res => {
            if (res.data.filter(wrench => wrench.showWrench).length === 0) {
                dispatch({type: actionTypes.SET_ACTIVE_DEVICE_SERVICE_REQUEST, typeOf: "value", value: false})
            } else {
                dispatch({type: actionTypes.SET_ACTIVE_DEVICE_SERVICE_REQUEST, typeOf: "value", value: true})
                toastError("Richiesta di servizio già in corso per alcune delle SIM selezionate");
            }
            dispatch({type: actionTypes.SET_WRENCH_DETAILS_DEVICE, wrenchDetails: res.data})
        })
            .catch(e => {
                console.log(e);
            })
            .then(() => {
                dispatch({type: actionTypes.SET_ACTIVE_DEVICE_SERVICE_REQUEST, typeOf: "loading", value: false})
                dispatch({type: actionTypes.SET_ACTIVE_DEVICE_SERVICE_REQUEST, typeOf: "value", value: false})
            })
    }
}

export const getCollaboratorsForDevice = (customerId, imeiList, areAllSelected = false) => {
    const getCollaboratorsForDeviceDto = {
        customerId: customerId,
        imeiList: imeiList,
        areAllSelected: areAllSelected
    };
    const filter = store.getState().deviceReducer.filter;
    const url = getUrlWithFilters('', 0, 25, customerId, filter);
    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_COLLABORATORS_DEVICE, loading: true});
        dispatch({type: actionTypes.SET_ERROR_COLLABORATORS_DEVICE, payload: false})
        DeviceService.fetchCollaborators(getCollaboratorsForDeviceDto, url).then(res => {
            dispatch({
                type: actionTypes.GET_COLLABORATORS_DEVICE,
                collaborators: res.data
            })
        }).catch(e => {
            console.log(e);
            dispatch({type: actionTypes.SET_ERROR_COLLABORATORS_DEVICE, payload: true})
        }).finally(() => {
            dispatch({type: actionTypes.SET_LOADING_COLLABORATORS_DEVICE, loading: false});
        })
    }
}

export const addCollaboratorsForDevice = (collaboratorsList, imeiList, customerId, areAllSelected) => {
    const addCollaboratorsDto = {
        getCollaboratorsResponseDtoList: collaboratorsList,
        idList: imeiList,
        customerId: customerId,
        areAllSelected: areAllSelected
    }
    const filter = store.getState().deviceReducer.filter;
    const url = getUrlWithFilters('', 0, 25, customerId, filter);

    DeviceService.addCollaborators(addCollaboratorsDto, url).then(() => {
        // This may take longer then expected because it's async and going through RabbitMQ
        toastSuccess("Operazione presa in carico")
    }).catch(e => {
        console.log(e);
    })
}

export const fetchDeviceTagsAutocomplete = (name) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return dispatch => {
        TagsService.fetchTagsAutocomplete(integrationId, DEVICE, APP_NAME, name).then(res => {
            dispatch({type: actionTypes.UPDATE_DEVICE_TAGS_AUTOCOMPLETE_SUCCESS, payload: res.data.data})
        }).catch(e => {
            console.log(e);
        })
    }
}

export const changeTagsForSelectedDevice = (tags, type) => {
    let tmpRow;
    if (type === "data") {
        tmpRow = {...store.getState().deviceReducer.collaborators}
    } else {
        tmpRow = {...store.getState().deviceReducer.deviceSelectedRow}
    }
    let tmpList = []
    let selectedTags = tags
    tmpRow[`${type}`].forEach(i => {
        let tmpObj = selectedTags.find(c => c.id === i.id)
        if (tmpObj) {
            tmpObj.checked = true
        } else {
            tmpObj = i
            tmpObj.checked = false
        }
        tmpList.push(tmpObj)
    })

    return {
        type: actionTypes.CHANGE_TAGS_DEVICE,
        tags: tmpList,
        forType: type
    };
}

export const setSortingDevice = (value) => {
    return {
        type: actionTypes.SET_SORTING_DEVICE,
        value: value
    };
};

export const removeDeviceFilter = (name, type, idx) => {
    let value;
    let date = "";
    if (type === "array") {
        value = [...store.getState().deviceReducer.filter[`${name}`].value];
        value.splice(idx, 1);
    } else if (type === "date") {
        value = {...store.getState().deviceReducer.filter[`${name}`]};
        value.from = null;
        value.to = null;
        date = "r";
    } else {
        value = "";
    }
    return {
        type: actionTypes.CHANGE_FILTER_DEVICE,
        name: name,
        value: value,
        date: date,
    };
};

export const changeFilterDevice = (name, value, date, text = "") => {
    return {
        type: actionTypes.CHANGE_FILTER_DEVICE,
        name: name,
        value: value,
        date: date,
        text: text
    };
};

export const resetFilterDevice = (val = initialFilterState) => {
    return {
        type: actionTypes.RESET_FILTER_DEVICE,
        payload: val
    }
}

export const setFilterClickedDevice = (val) => {
    return {
        type: actionTypes.SET_FILTER_CLICKED_DEVICE,
        val: val,
    };
};

export const updateModelloSelect = (val) => {
    const modello = store.getState().deviceReducer.filterData.models.filter(m => m.includes(val)).map(m => {
        return {
            text: m.split(" ").slice(1).join(" "), value: m.split(" ").slice(1).join(" ")
        }
    });
    return {
        type: actionTypes.UPDATE_MODELLO_SELECT,
        modello: modello
    }
}

export const setLoadingSuggestionDevice = (val) => {
    return {type: actionTypes.SET_DEVICE_SUGGESTION_LOADING, value: val}
}

export const clearSelectedRow = () => {
    return ({
        type: actionTypes.CLEAR_SELECTED_ROW_DEVICE,
    })
}

export const fetchDevicesForAssociazioneKasko = (sortBy, page, rowsPerPage, filter) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(sortBy, page, rowsPerPage, integrationId, filter);

    return dispatch => {
        dispatch({type: actionTypes.SET_DEVICE_ASSOCIAZIONE_LOADING, value: true})

        if (store.getState().deviceReducer.kaskoData.tableLoading) {
            deviceCancelToken.cancel();
            deviceCancelToken = axios.CancelToken.source();
        }

        DeviceService.fetchDevicesKaskoCustom(encodeData(url))
            .then(res => {
                dispatch(
                    {
                        type: actionTypes.SET_DEVICE_ASSOCIAZIONE_KASKO_CUSTOM,
                        tableData: res.data.devices,
                        maxToAssociate: res.data.maxToAssociate,
                        currentAssociated: res.data.currentAssociated
                    }
                )
            })
            .catch(e => {
                if (!axios.isCancel(e)) {
                    console.log(e)
                }
                dispatch(
                    {
                        type: actionTypes.SET_DEVICE_ASSOCIAZIONE_KASKO_CUSTOM,
                        tableData: [],
                        maxToAssociate: 0,
                        currentAssociated: 0
                    }
                )
            })
            .then(() => {
                dispatch({type: actionTypes.SET_DEVICE_ASSOCIAZIONE_LOADING, value: false})
            })
    }
}

export const fetchDevicesForDiassociazioneKasko = (sortBy, page, rowsPerPage, filter) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(sortBy, page, rowsPerPage, integrationId, filter);

    return dispatch => {
        dispatch({type: actionTypes.SET_DEVICE_ASSOCIAZIONE_LOADING, value: true})

        if (store.getState().deviceReducer.kaskoData.tableLoading) {
            deviceCancelToken.cancel();
            deviceCancelToken = axios.CancelToken.source();
        }

        DeviceService.fetchDevicesNotKaskoCustom(encodeData(url))
            .then(res => {
                dispatch(
                    {
                        type: actionTypes.SET_DEVICE_ASSOCIAZIONE_KASKO_CUSTOM,
                        tableData: res.data.devices,
                        maxToAssociate: res.data.maxToAssociate,
                        currentAssociated: res.data.currentAssociated
                    }
                )
            })
            .catch(e => {
                if (!axios.isCancel(e)) {
                    console.log(e)
                }
                dispatch(
                    {
                        type: actionTypes.SET_DEVICE_ASSOCIAZIONE_KASKO_CUSTOM,
                        tableData: [],
                        maxToAssociate: 0,
                        currentAssociated: 0
                    }
                )
            })
            .then(() => {
                dispatch({type: actionTypes.SET_DEVICE_ASSOCIAZIONE_LOADING, value: false})
            })
    }
}
